import { ChangePaymentDateValidatorErrors } from '../types';

export const ChangePaymentDateError: ChangePaymentDateValidatorErrors = {
    paymentDay: {
        required: 'Payment date is required.',
        oneOf: 'Please choose correct payment day option.',
    },
};
